import JhonDoeAvatar from "../../assets/testimonial1.png";
import HarryClintonAvatar from "../../assets/testimonial2.png";
import SaraCillAvatar from "../../assets/testimonial3.png";

export const Data = [
  {
    id: 1,
    image: JhonDoeAvatar,
    title: "Jhon Doe",
    description:
      "It's been a great experience and chance to collaborate with @bmassioui to turn my idea into real business.",
  },
  {
    id: 2,
    image: HarryClintonAvatar,
    title: "Harry Clinton",
    description:
      "@bmassioui is surely a well skilled software developer with strong expertise in software engineering.",
  },
  {
    id: 3,
    image: SaraCillAvatar,
    title: "Sara Cill",
    description:
      "@bmassioui is one among my preferred heroes in software development, he really delivers an incredible services.",
  },
];
